// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketing-tab__time-changer{margin-bottom:5px}
`, "",{"version":3,"sources":["webpack://./src/locations/marketing/elements/TimeChanger.scss"],"names":[],"mappings":"AAAA,6BACE,iBAAkB","sourcesContent":[".marketing-tab__time-changer {\n  margin-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
